module.exports = __webpack_public_path__ + "static/FSI-Award-fe4d1cd78314f7bf56ebb74f72572496.jpg";